// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionCircleTwoToneSvg from "@fishx/icons-svg/es/asn/QuestionCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var QuestionCircleTwoTone = function QuestionCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleTwoToneSvg
  }));
};

QuestionCircleTwoTone.displayName = 'QuestionCircleTwoTone';
export default React.forwardRef(QuestionCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QuestionCircleTwoTone.js
// module id = 3956
// module chunks = 0